
<p-card>
    <p-table [value]="lysinglist" [tableStyle]="{'min-width': '50rem'}" #dt
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['lysingInstrument','neutralizationInstrument']" [columns]="cols" stateStorage="local" stateKey="lysinglist-state">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="lysingInstrument" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Lysing Instrument
                        <p-sortIcon field="lysingInstrument"></p-sortIcon>
                        <p-columnFilter type="text" field="lysingInstrument" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="neutralizationInstrument" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Neutralization Instrument
                        <p-sortIcon field="neutralizationInstrument"></p-sortIcon>
                        <p-columnFilter type="text" field="neutralizationInstrument" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="wells" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Wells
                        <p-sortIcon field="wells"></p-sortIcon>
                        <p-columnFilter type="text" field="wells" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="lysingDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Lysing Date
                        <p-sortIcon field="lysingDate"></p-sortIcon>
                        <p-columnFilter type="date" field="lysingDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="ovenStartDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Oven Start Date
                        <p-sortIcon field="ovenStartDate"></p-sortIcon>
                        <p-columnFilter type="date" field="ovenStartDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="ovenEndDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Oven End Date
                        <p-sortIcon field="ovenEndDate"></p-sortIcon>
                        <p-columnFilter type="date" field="ovenEndDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="neutralizationDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Neutralization Date
                        <p-sortIcon field="neutralizationDate"></p-sortIcon>
                        <p-columnFilter type="date" field="neutralizationDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="lysingIncident" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Lysing Incident
                        <p-sortIcon field="lysingIncident"></p-sortIcon>
                        <p-columnFilter type="text" field="lysingIncident" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="lysingIncidentDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Lysing Incident Date
                        <p-sortIcon field="lysingIncidentDate"></p-sortIcon>
                        <p-columnFilter type="date" field="lysingIncidentDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="neutralizationIncident" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Neutralization Incident
                        <p-sortIcon field="neutralizationIncident"></p-sortIcon>
                        <p-columnFilter type="text" field="neutralizationIncident" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="neutralizationIncidentDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Neutralization Incident Date
                        <p-sortIcon field="neutralizationIncidentDate"></p-sortIcon>
                        <p-columnFilter type="date" field="neutralizationIncidentDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="lysingService" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Lysing Service
                        <p-sortIcon field="lysingService"></p-sortIcon>
                        <p-columnFilter type="text" field="lysingService" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="lysingServiceDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Lysing Service Date
                        <p-sortIcon field="lysingServiceDate"></p-sortIcon>
                        <p-columnFilter type="date" field="lysingServiceDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="neutralizationService" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Neutralization Service
                        <p-sortIcon field="neutralizationService"></p-sortIcon>
                        <p-columnFilter type="text" field="neutralizationService" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="neutralizationServiceDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Neutralization Service Date
                        <p-sortIcon field="neutralizationServiceDate"></p-sortIcon>
                        <p-columnFilter type="date" field="neutralizationServiceDate" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-lysing>
            <tr (click)="rowClick(lysing)">
                <td>{{lysing.lysingInstrument}}</td>
                <td>{{lysing.neutralizationInstrument}}</td>
                <td>{{lysing.wells}}</td>
                <td>{{lysing.lysingDate | date:'short'}}</td>
                <td>{{lysing.ovenStartDate | date:'short'}}</td>
                <td>{{lysing.ovenEndDate | date:'short'}}</td>
                <td>{{lysing.neutralizationDate | date:'short'}}</td>
                <td>{{lysing.lysingIncident}}</td>
                <td>{{lysing.lysingIncidentDate | date:'short'}}</td>
                <td>{{lysing.neutralizationIncident}}</td>
                <td>{{lysing.neutralizationIncidentDate | date:'short'}}</td>
                <td>{{lysing.lysingService}}</td>
                <td>{{lysing.lysingServiceDate | date:'short'}}</td>
                <td>{{lysing.neutralizationService}}</td>
                <td>{{lysing.neutralizationServiceDate | date:'short'}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>